import Vue from "vue";
import Vuex from "vuex";

import persistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userinfo: null, // 用户信息
    skk_img_captcha_session: null, // 验证码
  },
  mutations: {
    // 设置用户信息
    setUserInfo(state, data) {
      // console.log('设置用户信息', data)
      state.userinfo = data;
    },
    // 用户已读登记信息须知
    changeReadStatus(state, data) {
      // console.log('设置用户信息', data)
      //改变用户未读状态
      state.userinfo.company_info.is_look_agre = data;
      // console.log(data)
    },
    /**
     * 设置session_id
     */
    SKK_SET_IMG_CAPTCHA_SESSION(state, data) {
      state.skk_img_captcha_session = data;
    },
  },
  actions: {
    skkSetImgCaptchaSession({ commit }, data) {
      commit("SKK_SET_IMG_CAPTCHA_SESSION", data);
    },
    setSkkWellBeYear({ commit }, data) {
      commit("SKK_SET_WILL_BE_YEAR", data);
    },
    logout({ commit }, data = null) {
      commit("setUserInfo", data);
    },
    createPerItem({ commit }, data) {
      commit("SKK_PUSH_PER_LIST", data);
    },
    handlerDeletePerImte({ commit }, index) {
      commit("handlerDeletePerImte", index);
    },
    handlerCleraPreList({ commit }) {
      commit("handlerCleraPreList");
    },
  },
  modules: {},
  // vuex-persistedstate存储到sessionStorage 无痕模式
  // sessionStorage 方法针对一个 session 进行数据存储。当用户关闭浏览器窗口后，数据会被删除。
  // plugins: [persistedState({ storage: window.sessionStorage })],

  // localStorage 方法存储的数据没有时间限制。第二天、第二周或下一年之后，数据依然可用。
  plugins: [persistedState()],
  getters: {
    skk_img_ca_session: (state) => state.skk_img_captcha_session,
    skk_token: (state) => state.userinfo.token,
  },
});
